import { LoadScriptFunction } from './LoadScript.types';

/**
 * Dynamically loads a script source. Returns a promise that resolves when the script has loaded.
 *
 * @param scriptSource - The script source.
 * @param scriptKey - The script key. Must be unique by source.
 */
export const loadScript: LoadScriptFunction = (scriptSource, scriptKey) => {
    return new Promise<void>((resolve, reject) => {
        const scriptExistsInDocument: HTMLElement | null = document.getElementById(scriptKey);

        if (!scriptExistsInDocument) {
            const script: HTMLScriptElement = document.createElement('script');

            script.id = scriptKey;
            script.onload = () => resolve();
            script.onerror = () => reject();
            script.src = process.env.PUBLIC_URL + scriptSource;

            document.body.appendChild(script);
        }
        else {
            resolve();
        }
    });
};
